import { castError } from 'helpers/logger/castError';

import { getGlobalObject } from './utils/getGlobalObject';

export const addRumError = (error: unknown, context?: Record<string, unknown>): boolean => {
  const normalizedError = castError(error);
  const rum = getGlobalObject<Window>().DD_RUM;
  if (!rum || !normalizedError) return false;

  rum.addError(normalizedError, context);
  return true;
};
